var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoReal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 34.0006C26.3888 34.0006 34 26.3893 34 17.0003C34 7.6113 26.3888 0 17 0C7.61116 0 0 7.6113 0 17.0003C0 26.3893 7.61116 34.0006 17 34.0006ZM10.877 11.3775C8.96739 12.1685 7.23227 13.3279 5.77071 14.7895C8.718 19.186 12.5 22.9687 16.9003 25.919C21.3006 22.9687 25.0826 19.186 28.0299 14.7895C26.5683 13.3279 24.8332 12.1685 22.9236 11.3775C21.014 10.5866 18.9672 10.1794 16.9003 10.1794C14.8333 10.1794 12.7866 10.5866 10.877 11.3775Z",
    fill: "#20C58A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoReal);
export default __webpack_public_path__ + "static/media/logo-real.6e29a054f00f85085ecb4bc94a9d213e.svg";
export { ForwardRef as ReactComponent };